import type {
    GetOrganisationDocumentsResponse,
    OrganisationDocument,
} from "@lib/api/getOrganisationDocuments";

const withAuthParams = (url: string) => {
    const userID = localStorage.getItem("Meteor.userId") || "";
    const logasID = localStorage.getItem("side_team_logasId");
    const token = localStorage.getItem("Meteor.loginToken") || "";

    return `${url}?X-User-ID=${userID}&X-Auth-Token=${token}${
        logasID ? `&X-Logas-ID=${logasID}` : ""
    }`;
};

export const normalizeDocument = (document: OrganisationDocument) => ({
    documentId: document._id,
    taskId: document.taskId,
    taskName: document.taskName,
    organisationId: document.organisationId,
    organisationName: document.organisationName,
    status: document.status,
    managerName: document.managerName,
    generation: {
        url: withAuthParams(document.url),
    },
    contractsIds: document.contractIds ?? [],
    startDate: document.startDate,
    signature: document.signature
        ? {
              url: withAuthParams(document.signature.url),
              date: document.signature.date,
              managerName: document.signature.name,
          }
        : null,
    contestation: document.contestation
        ? {
              managerName: document.contestation.name,
              date: document.contestation.date,
              description: document.contestation.reason,
          }
        : null,
});

export const normalizeDocuments = (data: GetOrganisationDocumentsResponse) => ({
    ...data,
    documents: (data.documents ?? []).map(normalizeDocument),
});
